module.exports = __webpack_public_path__ + "static/media/avatar-10.2a4760b0.svg";